/*
 * デザインシミュレーターの専用ページ（/pages/design）のアイテム選択。2026-10-06 作り直し（ユーザー了承のモック
 * mockup-sim/sim-list-mobile-mock-2026-10-06.html）。画面は sections/main-design-page.liquid の [data-pz-dsel]、
 * 見た目は assets/pz-design-select.css。
 * - 検索: 商品名・品番（ハイフン・全角半角を気にしない）・ブランド・種類・タグ・呼び方（ロンT・ポロ・トレーナーなど）。
 *   デザインID（編集リンクも）が入れば、上に「このデザインを開く」を出す
 * - 種類のボタン・並び替え・絞り込み（価格・生地の厚さ・素材・ブランド・サイズ・できる加工）。選んだ条件は上に並び、押すと外せる。
 *   条件はこのタブの間だけ覚える（エディタから戻ったときに元の一覧に戻すため）
 * - カードを押すと詳細（写真・値段・生地・できる加工・説明・カラーチャート・サイズ表）が下から開く（PC は中央）。
 *   下に引く・外を押す・×・Esc で閉じる。写真・説明・チャートは /products/{handle}.js から読む
 *   （商品ページと同じく、画像の alt が color_chart / size_chart のものがチャート。写真の一覧には出さない）
 * - マイデザイン（ログイン中で保存したデザインがあるとき）: 帯を押すと開く・たたむ（この端末に覚える）。検索に文字がある間はたたむ
 * デザインID の判定・URL・マイデザインの読み込みは window.PzDesign（assets/pz-design-embed.js。先に読まれる）を使う。
 */
(function () {
  'use strict';

  const STATE_KEY = 'pz-dsel-state';
  const MY_KEY = 'pz-dsel-my';

  function nfkc(s) {
    s = String(s == null ? '' : s);
    try {
      return s.normalize('NFKC');
    } catch (e) {
      return s;
    }
  }

  /* 探すときの形: 全角半角・大文字小文字・空白・ハイフン・長音・中黒を気にしない */
  function norm(s) {
    return nfkc(s).toLowerCase().replace(/[\s\-‐‑‒–—―－ー_・･]/g, '');
  }

  /* 呼び方の読み替え（言葉 1 つがこれと同じとき） */
  const ALIAS = [
    ['ロンt', 'ロングtシャツ'],
    ['ロンティー', 'ロングtシャツ'],
    ['ポロ', 'ポロシャツ'],
    ['トレーナー', 'スウェット'],
    ['フーディ', 'パーカー'],
    ['フーディー', 'パーカー'],
    ['タンク', 'タンクトップ'],
    ['ティーシャツ', 'tシャツ']
  ].map(function (p) {
    return [norm(p[0]), norm(p[1])];
  });

  /* 商品名の後ろの品番（例「… (UA-500101)」）は、カードと詳細の見出しでは出さない（探すときは品番も使う） */
  function displayName(name) {
    return String(name || '').replace(/\s*[（(]\s*[A-Za-z]{1,8}[-\s]?[0-9A-Za-z][0-9A-Za-z\-]*\s*[)）]\s*$/, '') || String(name || '');
  }

  function yen(n) {
    return '¥' + Number(n).toLocaleString('ja-JP');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function storage(kind) {
    try {
      return kind === 'local' ? window.localStorage : window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  function readStore(kind, key) {
    const st = storage(kind);
    if (!st) return null;
    try {
      return st.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(kind, key, value) {
    const st = storage(kind);
    if (!st) return;
    try {
      if (value == null) st.removeItem(key);
      else st.setItem(key, value);
    } catch (e) {
      /* 保存できなくても動く */
    }
  }

  function pz() {
    return window.PzDesign || null;
  }

  /* ------------------------------------------------------------------ */
  /* エディタの先読み                                                      */
  /* ------------------------------------------------------------------ */

  /* デザイン用ホストのオリジン（assets/pz-design-embed.js が data-design-origin から決めた値。https のオリジンだけ。無ければ空） */
  function designOrigin() {
    const p = pz();
    let o = p && p.config && p.config.designOrigin;
    if (!o) {
      const n = document.querySelector('[data-pz-design-page]');
      o = n && n.getAttribute('data-design-origin');
    }
    try {
      const u = new URL(String(o || ''));
      return u.protocol === 'https:' ? u.origin : '';
    } catch (e) {
      return '';
    }
  }

  /*
   * お客様が「この商品で作る」を押しそうなとき（商品の詳細を開いた・「この商品で作る」に触れた）に、見えない iframe でデザイン用ホストの
   * /design/warmup を開く。エディタが最初に読む JS と書体の css をブラウザのキャッシュに入れておくだけの画面で、エディタ（?product= で開く
   * iframe）は同じキャッシュを使うので、押した後の読み込みが短くなる（portal の src/app/(editor)/design/warmup）。
   * このページを開いている間に 1 回だけ。通信量を抑える設定・遅い回線（2g）のときは開かない。
   */
  let warmedUp = false;
  function warmUpEditor() {
    if (warmedUp) return;
    warmedUp = true;
    try {
      const conn = navigator.connection;
      if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
      const origin = designOrigin();
      if (!origin) return;
      const f = document.createElement('iframe');
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.setAttribute('loading', 'eager');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      f.setAttribute('width', '0');
      f.setAttribute('height', '0');
      f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;pointer-events:none';
      f.src = origin + '/design/warmup';
      document.body.appendChild(f);
    } catch (e) {
      /* 先読みはなくても動く */
    }
  }

  /* 画像の URL に幅を付ける（Shopify の CDN） */
  function sized(url, width) {
    if (!url) return '';
    let u = String(url);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  /* ------------------------------------------------------------------ */
  /* アイテム（カードの data-* から）                                       */
  /* ------------------------------------------------------------------ */

  function readItems(root) {
    const list = [];
    root.querySelectorAll('[data-pz-dsel-groups] [data-pz-item]').forEach(function (li, idx) {
      const tags = (li.getAttribute('data-tags') || '').split('|').filter(Boolean);
      const name = li.getAttribute('data-name') || '';
      let oz = parseFloat(li.getAttribute('data-oz') || '');
      if (!(oz > 0)) {
        const m = /([\d.]+)\s*oz/i.exec(name);
        oz = m ? parseFloat(m[1]) : NaN;
      }
      const pick = function (prefix) {
        return tags.filter(function (t) { return t.indexOf(prefix) === 0; }).map(function (t) { return t.slice(prefix.length).trim(); });
      };
      const card = li.querySelector('.pz-dpage__card');
      const img = li.querySelector('img');
      const simImg = li.querySelector('.pz-scard__img');
      const item = {
        li: li,
        idx: idx,
        code: li.getAttribute('data-code') || '',
        cat: li.getAttribute('data-cat') || '',
        brand: li.getAttribute('data-brand') || '',
        name: name,
        price: parseInt(li.getAttribute('data-price') || '', 10),
        oz: oz > 0 ? oz : null,
        tags: tags,
        mat: pick('素材:')[0] || '',
        sizes: pick('サイズ:'),
        meth: pick('加工:'),
        created: parseInt(li.getAttribute('data-created') || '0', 10) || 0,
        handle: li.getAttribute('data-handle') || '',
        href: card ? card.getAttribute('href') : '',
        img: img ? img.currentSrc || img.src : '',
        simImg: simImg ? simImg.getAttribute('src') : ''
      };
      item.hay = norm([item.name, item.brand, item.code, item.cat, tags.join(' ')].join(' '));
      item.label = displayName(name);
      const nameEl = li.querySelector('.pz-dpage__card-name');
      if (nameEl && item.label !== name) nameEl.textContent = item.label;
      list.push(item);
    });
    return list;
  }

  function matchQuery(item, q) {
    if (!q) return true;
    return q.split(/\s+/).filter(Boolean).every(function (t) {
      let nt = norm(t);
      for (let i = 0; i < ALIAS.length; i++) if (nt === ALIAS[i][0]) nt = ALIAS[i][1];
      return item.hay.indexOf(nt) >= 0;
    });
  }

  const BIG = ['3XL', '4XL', '5XL', '6XL', '3L', '4L', '5L', '6L', '7L', 'XXXL'];
  const KIDS = ['キッズ', '90', '100', '110', '120', '130', '140', '150', '160', 'YL', 'YM', 'YS'];
  const SMALL = ['XS', 'SS', 'WM', 'WL'];
  function hasAny(list, wanted) {
    return list.some(function (v) { return wanted.indexOf(nfkc(v).toUpperCase()) >= 0 || wanted.indexOf(v) >= 0; });
  }

  /*
   * アクリルキーホルダーかどうか（タグ「アクリルキーホルダー」か「加工:UVプリント」。見分けるのはここだけ）。
   * 詳細の言葉を変える: 価格は 1 個あたり・プリント込み、できる加工は UV プリントだけ、サイズ表が無ければ欄ごと出さない。
   * 服など、それ以外の商品は今までどおり
   */
  function isAcrylic(d) {
    return d.tags.indexOf('アクリルキーホルダー') >= 0 || d.meth.indexOf('UVプリント') >= 0;
  }

  /* アクリルキーホルダーの 1 カラーの最少個数（商品の料金区分から読めないときの値） */
  const ACRYLIC_MIN_QTY = 5;

  /* 商品（/products/{handle}.js）の料金区分（オプションの値「5個」「10〜29個」「50個以上」…）のいちばん小さい数。読めなければ null */
  function acrylicMinQty(p) {
    const opts = p && Array.isArray(p.options) ? p.options : [];
    const tier = opts.filter(function (o) { return o && o.name === '料金区分' && Array.isArray(o.values); })[0];
    if (!tier) return null;
    const nums = tier.values.map(function (v) { return parseInt(nfkc(v), 10); }).filter(function (n) { return n > 0; });
    return nums.length ? Math.min.apply(null, nums) : null;
  }

  /* アクリルキーホルダーの価格の下の文 */
  function acrylicPriceNote(minQty) {
    return '個数・両面プリント・グロス加工で 1 個あたりの価格が変わります。1 カラー ' + minQty + ' 個からご注文いただけます。';
  }

  /* 絞り込みの決まり（同じ種類の中は「どれか」、種類どうしは「全部」） */
  function buildGroups(items) {
    const brands = {};
    const mats = {};
    items.forEach(function (it) {
      if (it.brand) brands[it.brand] = (brands[it.brand] || 0) + 1;
      if (it.mat) mats[it.mat] = (mats[it.mat] || 0) + 1;
    });
    const byCount = function (obj) {
      return Object.keys(obj).sort(function (a, b) { return obj[b] - obj[a]; });
    };
    return [
      {
        key: 'price',
        label: '価格（本体 1 枚）',
        opts: [
          ['〜¥999', function (d) { return d.price < 1000; }],
          ['¥1,000〜1,999', function (d) { return d.price >= 1000 && d.price < 2000; }],
          ['¥2,000〜2,999', function (d) { return d.price >= 2000 && d.price < 3000; }],
          ['¥3,000〜', function (d) { return d.price >= 3000; }]
        ]
      },
      {
        key: 'oz',
        label: '生地の厚さ',
        opts: [
          ['薄手（〜5.0oz）', function (d) { return d.oz != null && d.oz <= 5.0; }],
          ['ふつう（5.1〜6.0oz）', function (d) { return d.oz != null && d.oz > 5.0 && d.oz <= 6.0; }],
          ['厚手（6.1〜7.9oz）', function (d) { return d.oz != null && d.oz > 6.0 && d.oz < 8; }],
          ['とても厚手（8oz〜）', function (d) { return d.oz != null && d.oz >= 8; }]
        ]
      },
      {
        key: 'mat',
        label: '素材',
        opts: byCount(mats).map(function (m) { return [m, function (d) { return d.mat === m; }]; })
      },
      {
        key: 'brand',
        label: 'ブランド',
        opts: byCount(brands).map(function (b) { return [b, function (d) { return d.brand === b; }]; })
      },
      {
        key: 'size',
        label: 'サイズ',
        opts: [
          ['大きいサイズ（3XL〜）', function (d) { return hasAny(d.sizes, BIG); }],
          ['キッズサイズ', function (d) { return hasAny(d.sizes, KIDS); }],
          ['小さいサイズ（XS・SS）', function (d) { return hasAny(d.sizes, SMALL); }]
        ]
      },
      {
        key: 'meth',
        label: 'できる加工',
        opts: [
          ['刺繍', function (d) { return d.meth.indexOf('刺繍') >= 0; }],
          ['フルカラープリント', function (d) { return d.meth.indexOf('フルカラープリント') >= 0; }],
          ['スクリーンプリント', function (d) { return d.meth.indexOf('スクリーンプリント') >= 0; }]
        ]
      }
    ].filter(function (g) { return g.opts.length > 0; });
  }

  const SORTS = [
    ['rec', 'おすすめ順'],
    ['cheap', '価格の安い順'],
    ['exp', '価格の高い順'],
    ['thick', '生地が厚い順'],
    ['thin', '生地が薄い順'],
    ['new', '新しい順']
  ];

  function sortItems(list, key) {
    const s = list.slice();
    const num = function (v, missing) { return v == null || isNaN(v) ? missing : v; };
    if (key === 'cheap') s.sort(function (a, b) { return num(a.price, 1e9) - num(b.price, 1e9) || a.idx - b.idx; });
    if (key === 'exp') s.sort(function (a, b) { return num(b.price, -1) - num(a.price, -1) || a.idx - b.idx; });
    if (key === 'thick') s.sort(function (a, b) { return num(b.oz, -1) - num(a.oz, -1) || a.idx - b.idx; });
    if (key === 'thin') s.sort(function (a, b) { return num(a.oz, 1e9) - num(b.oz, 1e9) || a.idx - b.idx; });
    if (key === 'new') s.sort(function (a, b) { return b.created - a.created || a.idx - b.idx; });
    return s;
  }

  /* ------------------------------------------------------------------ */
  /* 下から上がる画面（絞り込み・詳細）                                     */
  /* ------------------------------------------------------------------ */

  function Sheets(root) {
    this.root = root;
    this.dim = root.querySelector('[data-pz-dsel-dim]');
    this.current = null;
    this.returnFocus = null;
    const self = this;
    if (this.dim) this.dim.addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) {
      if (self.current && (e.key === 'Escape' || e.key === 'Esc')) self.close();
    });
    root.querySelectorAll('[data-pz-dsel-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
  }

  Sheets.prototype.open = function (el) {
    if (this.current && this.current !== el) this.close(true);
    this.current = el;
    this.returnFocus = document.activeElement;
    el.hidden = false;
    el.style.transform = '';
    document.documentElement.classList.add('pz-dsel-lock');
    if (this.dim) this.dim.classList.add('is-on');
    /* 1 フレーム待ってから出す（hidden を外した直後だと動きが付かない） */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open');
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          el.focus();
        }
      });
    });
  };

  Sheets.prototype.close = function (instant) {
    const el = this.current;
    if (!el) return;
    this.current = null;
    el.classList.remove('is-open', 'is-dragging');
    el.style.transform = '';
    if (this.dim) this.dim.classList.remove('is-on');
    document.documentElement.classList.remove('pz-dsel-lock');
    const hide = function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
    };
    if (instant) hide();
    else setTimeout(hide, 320);
    const back = this.returnFocus;
    this.returnFocus = null;
    if (back && typeof back.focus === 'function' && document.contains(back)) {
      try {
        back.focus({ preventScroll: true });
      } catch (e) {
        /* 戻せなくてもよい */
      }
    }
  };

  /* 詳細を下に引いて閉じる（つまみ・見出しはいつでも、本文は一番上までスクロールしているときだけ。スマホの幅だけ） */
  function enableDragToClose(sheet, body, sheets) {
    let startY = 0;
    let lastY = 0;
    let lastT = 0;
    let vel = 0;
    let dragging = false;
    let fromBody = false;
    const wide = function () {
      return window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    };
    function down(y, isBody) {
      if (wide()) return;
      if (isBody && body.scrollTop > 0) return;
      dragging = true;
      fromBody = isBody;
      startY = lastY = y;
      lastT = performance.now();
      vel = 0;
    }
    function move(y, ev) {
      if (!dragging) return;
      const dy = y - startY;
      if (fromBody && dy <= 0) {
        dragging = false;
        return;
      }
      const now = performance.now();
      vel = (y - lastY) / Math.max(1, now - lastT);
      lastY = y;
      lastT = now;
      sheet.classList.add('is-dragging');
      sheet.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
      if (fromBody && ev && ev.cancelable) ev.preventDefault();
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      const dy = lastY - startY;
      sheet.classList.remove('is-dragging');
      if (dy > 110 || vel > 0.6) sheets.close();
      else sheet.style.transform = '';
    }
    sheet.querySelectorAll('[data-pz-dsel-drag]').forEach(function (el) {
      el.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('[data-pz-dsel-close]')) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        try {
          el.setPointerCapture(e.pointerId);
        } catch (err) {
          /* 取れなくても動く */
        }
        down(e.clientY, false);
      });
      el.addEventListener('pointermove', function (e) { move(e.clientY, null); });
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
    });
    body.addEventListener('touchstart', function (e) { down(e.touches[0].clientY, true); }, { passive: true });
    body.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      move(e.touches[0].clientY, e);
    }, { passive: false });
    body.addEventListener('touchend', up);
    body.addEventListener('touchcancel', up);
  }

  /* ------------------------------------------------------------------ */
  /* 本体                                                                 */
  /* ------------------------------------------------------------------ */

  function init(root) {
    if (root.__pzDsel) return;
    root.__pzDsel = true;
    /* エディタを開いている（?product= / ?id=）ときは何もしない */
    if (root.hidden || document.documentElement.classList.contains('pz-design-link')) return;

    const items = readItems(root);
    if (!items.length) return;
    const groups = buildGroups(items);
    const cats = [];
    items.forEach(function (it) {
      if (it.cat && cats.indexOf(it.cat) < 0) cats.push(it.cat);
    });

    const el = {
      bar: root.querySelector('[data-pz-dsel-bar]'),
      q: root.querySelector('[data-pz-dsel-q]'),
      clear: root.querySelector('[data-pz-dsel-clear]'),
      tune: root.querySelector('[data-pz-dsel-open-filter]'),
      badge: root.querySelector('[data-pz-dsel-badge]'),
      chips: root.querySelector('[data-pz-dsel-chips]'),
      active: root.querySelector('[data-pz-dsel-active]'),
      idhit: root.querySelector('[data-pz-dsel-idhit]'),
      status: root.querySelector('[data-pz-dsel-status]'),
      results: root.querySelector('[data-pz-dsel-results]'),
      empty: root.querySelector('[data-pz-dsel-empty]'),
      groupsWrap: root.querySelector('[data-pz-dsel-groups]'),
      filter: root.querySelector('[data-pz-dsel-filter]'),
      filters: root.querySelector('[data-pz-dsel-filters]'),
      apply: root.querySelector('[data-pz-dsel-apply]'),
      reset: root.querySelector('[data-pz-dsel-reset]'),
      detail: root.querySelector('[data-pz-dsel-detail]'),
      detailTitle: root.querySelector('[data-pz-dsel-detail-title]'),
      detailBody: root.querySelector('[data-pz-dsel-detail-body]'),
      make: root.querySelector('[data-pz-dsel-make]'),
      my: root.querySelector('[data-pz-dsel-my]')
    };
    if (!el.bar || !el.q) return;
    el.bar.hidden = false;
    /* 「この商品で作る」に触れた（マウスを載せた・指で触れた・キーボードで来た）ら、エディタの先読み（詳細を開いたときにもしている） */
    if (el.make) {
      ['pointerenter', 'pointerdown', 'touchstart', 'focus'].forEach(function (type) {
        el.make.addEventListener(type, warmUpEditor, { passive: true });
      });
    }

    const sheets = new Sheets(root);
    const state = { q: '', cat: 'all', sel: {}, sort: 'rec' };

    /* 前の条件（このタブの間だけ） */
    try {
      const saved = JSON.parse(readStore('session', STATE_KEY) || 'null');
      if (saved && typeof saved === 'object') {
        state.q = typeof saved.q === 'string' ? saved.q.slice(0, 100) : '';
        state.cat = cats.indexOf(saved.cat) >= 0 ? saved.cat : 'all';
        state.sort = SORTS.some(function (s) { return s[0] === saved.sort; }) ? saved.sort : 'rec';
        if (saved.sel && typeof saved.sel === 'object') {
          groups.forEach(function (g) {
            const want = Array.isArray(saved.sel[g.key]) ? saved.sel[g.key] : [];
            const ok = want.filter(function (l) { return g.opts.some(function (o) { return o[0] === l; }); });
            if (ok.length) state.sel[g.key] = ok;
          });
        }
      }
    } catch (e) {
      /* 読めなければ最初から */
    }
    el.q.value = state.q;

    function save() {
      writeStore('session', STATE_KEY, JSON.stringify(state));
    }

    function passFilters(d, exceptKey) {
      return groups.every(function (g) {
        if (g.key === exceptKey) return true;
        const on = state.sel[g.key] || [];
        if (!on.length) return true;
        return g.opts.some(function (o) { return on.indexOf(o[0]) >= 0 && o[1](d); });
      });
    }

    function countSelected() {
      return Object.keys(state.sel).reduce(function (n, k) { return n + state.sel[k].length; }, 0);
    }

    function currentHits() {
      return items.filter(function (d) {
        return matchQuery(d, state.q) && passFilters(d) && (state.cat === 'all' || d.cat === state.cat);
      });
    }

    function designIdOf(q) {
      const p = pz();
      if (!q || !p || typeof p.parseDesignInput !== 'function') return null;
      const r = p.parseDesignInput(q);
      return r && r.ok ? r : null;
    }

    function renderChips() {
      const pool = items.filter(function (d) { return matchQuery(d, state.q) && passFilters(d); });
      const list = [['all', 'すべて', pool.length]].concat(cats.map(function (c) {
        return [c, c, pool.filter(function (d) { return d.cat === c; }).length];
      }));
      el.chips.innerHTML = list.map(function (c) {
        return '<button type="button" class="pz-dsel__chip" data-cat="' + escapeHtml(c[0]) + '" aria-pressed="' + (state.cat === c[0] ? 'true' : 'false') + '">' +
          escapeHtml(c[1]) + '<small>' + c[2] + '</small></button>';
      }).join('');
    }

    function renderActive() {
      const parts = [];
      if (state.sort !== 'rec') {
        const label = SORTS.filter(function (s) { return s[0] === state.sort; })[0][1];
        parts.push('<button type="button" class="pz-dsel__cond" data-cond-sort="1" aria-label="' + escapeHtml(label) + 'をやめる">' + escapeHtml(label) + '</button>');
      }
      Object.keys(state.sel).forEach(function (g) {
        state.sel[g].forEach(function (l) {
          parts.push('<button type="button" class="pz-dsel__cond" data-cond-g="' + escapeHtml(g) + '" data-cond-l="' + escapeHtml(l) + '" aria-label="' + escapeHtml(l) + 'を外す">' + escapeHtml(l) + '</button>');
        });
      });
      const n = parts.length;
      if (n) parts.push('<button type="button" class="pz-dsel__cond pz-dsel__cond--all" data-cond-all="1">すべて外す</button>');
      el.active.innerHTML = parts.join('');
      el.active.hidden = n === 0;
      el.badge.hidden = n === 0;
      el.badge.textContent = n ? String(n) : '';
    }

    function render() {
      const q = state.q.trim();
      el.clear.hidden = !q;
      renderChips();
      renderActive();

      const id = designIdOf(q);
      el.idhit.innerHTML = '';
      if (id) {
        const p = pz();
        const href = p && p.designPageUrl ? p.designPageUrl(id, true) : '?id=' + encodeURIComponent(id.id);
        const shown = p && p.formatPublicId ? p.formatPublicId(id.id) : id.id;
        const a = document.createElement('a');
        a.className = 'pz-dsel__idhit';
        a.href = href;
        a.innerHTML = '<span>デザイン <b>' + escapeHtml(shown) + '</b> を開く</span><span aria-hidden="true">›</span>';
        el.idhit.appendChild(a);
      }

      const plain = !q && state.cat === 'all' && countSelected() === 0 && state.sort === 'rec';
      const hits = sortItems(currentHits(), state.sort);
      if (plain) {
        el.groupsWrap.hidden = false;
        el.results.hidden = true;
        el.results.innerHTML = '';
        el.empty.hidden = true;
        root.querySelectorAll('[data-pz-dsel-group]').forEach(function (g) {
          const n = g.querySelectorAll('[data-pz-item]').length;
          const c = g.querySelector('[data-pz-dsel-group-count]');
          if (c) c.textContent = n + ' 点';
        });
      } else {
        el.groupsWrap.hidden = true;
        el.results.innerHTML = '';
        const frag = document.createDocumentFragment();
        hits.forEach(function (d) { frag.appendChild(d.li.cloneNode(true)); });
        el.results.appendChild(frag);
        el.results.hidden = hits.length === 0;
        el.empty.hidden = hits.length > 0 || !!id;
      }
      if (el.status) el.status.textContent = plain ? '' : hits.length + ' 点';
      applyMy();
      save();
    }

    /* 絞り込みの画面 */
    function renderFilters() {
      const sortHtml = '<div class="pz-dsel__fgroup"><h4>並び替え</h4><div class="pz-dsel__opts">' + SORTS.map(function (s) {
        return '<button type="button" class="pz-dsel__opt" data-sort="' + s[0] + '" aria-pressed="' + (state.sort === s[0] ? 'true' : 'false') + '">' + escapeHtml(s[1]) + '</button>';
      }).join('') + '</div></div>';
      const groupHtml = groups.map(function (g) {
        const others = items.filter(function (d) {
          return matchQuery(d, state.q) && passFilters(d, g.key) && (state.cat === 'all' || d.cat === state.cat);
        });
        const on = state.sel[g.key] || [];
        const opts = g.opts.map(function (o) {
          const n = others.filter(o[1]).length;
          const pressed = on.indexOf(o[0]) >= 0;
          if (!n && !pressed) return '';
          return '<button type="button" class="pz-dsel__opt" data-g="' + g.key + '" data-l="' + escapeHtml(o[0]) + '" aria-pressed="' + (pressed ? 'true' : 'false') + '">' +
            escapeHtml(o[0]) + '<small>' + n + '</small></button>';
        }).join('');
        if (!opts) return '';
        return '<div class="pz-dsel__fgroup"><h4>' + escapeHtml(g.label) + '</h4><div class="pz-dsel__opts">' + opts + '</div></div>';
      }).join('');
      el.filters.innerHTML = sortHtml + groupHtml;
      el.apply.textContent = currentHits().length + ' 点を見る';
    }

    el.filters.addEventListener('click', function (e) {
      const b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-sort')) {
        state.sort = b.getAttribute('data-sort');
      } else if (b.hasAttribute('data-g')) {
        const g = b.getAttribute('data-g');
        const l = b.getAttribute('data-l');
        const cur = state.sel[g] || [];
        const next = cur.indexOf(l) >= 0 ? cur.filter(function (x) { return x !== l; }) : cur.concat([l]);
        if (next.length) state.sel[g] = next;
        else delete state.sel[g];
      } else {
        return;
      }
      renderFilters();
      render();
    });

    el.tune.addEventListener('click', function () {
      renderFilters();
      sheets.open(el.filter);
    });
    el.apply.addEventListener('click', function () { sheets.close(); });
    el.reset.addEventListener('click', function () {
      state.sel = {};
      state.sort = 'rec';
      renderFilters();
      render();
    });

    el.chips.addEventListener('click', function (e) {
      const b = e.target.closest('[data-cat]');
      if (!b) return;
      state.cat = b.getAttribute('data-cat');
      render();
    });

    el.active.addEventListener('click', function (e) {
      const b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-cond-all')) {
        state.sel = {};
        state.sort = 'rec';
      } else if (b.hasAttribute('data-cond-sort')) {
        state.sort = 'rec';
      } else {
        const g = b.getAttribute('data-cond-g');
        const l = b.getAttribute('data-cond-l');
        const next = (state.sel[g] || []).filter(function (x) { return x !== l; });
        if (next.length) state.sel[g] = next;
        else delete state.sel[g];
      }
      render();
    });

    let typing = null;
    el.q.addEventListener('input', function () {
      clearTimeout(typing);
      typing = setTimeout(function () {
        state.q = el.q.value;
        render();
      }, 120);
    });
    el.q.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      const hit = el.idhit.querySelector('a');
      e.preventDefault();
      if (hit) window.location.href = hit.getAttribute('href');
      else el.q.blur();
    });
    el.clear.addEventListener('click', function () {
      el.q.value = '';
      state.q = '';
      render();
      el.q.focus();
    });

    /* ---------------- 詳細 ---------------- */
    const productCache = {};
    function loadProduct(handle) {
      if (!handle) return Promise.resolve(null);
      if (productCache[handle]) return productCache[handle];
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return productCache[handle];
    }

    function plainText(html) {
      const box = document.createElement('div');
      box.innerHTML = String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h\d)>/gi, '\n');
      return (box.textContent || '').replace(/[ \t]+/g, ' ').replace(/\n\s*\n+/g, '\n').trim();
    }

    function methodsHtml(d) {
      /* アクリルキーホルダーは UV プリントだけ（スクリーン・フルカラー・刺繍の並びは出さない。色はフルカラーと同じ） */
      if (isAcrylic(d)) return '<span class="is-full">UVプリント</span>';
      const has = function (m) { return d.meth.indexOf(m) >= 0; };
      if (!d.meth.length) return '';
      return [['スクリーンプリント', 'スクリーン', 'is-screen'], ['フルカラープリント', 'フルカラー', 'is-full'], ['刺繍', '刺繍', 'is-emb']].map(function (m) {
        return '<span class="' + (has(m[0]) ? m[2] : 'is-no') + '">' + m[1] + '</span>';
      }).join('');
    }

    let detailToken = 0;
    function openDetail(d) {
      const token = ++detailToken;
      warmUpEditor();
      el.detailTitle.textContent = d.label;
      el.make.setAttribute('href', d.href || el.make.getAttribute('href'));
      const specs = [];
      if (d.oz) specs.push(d.oz + 'oz');
      if (d.mat) specs.push(d.mat);
      if (hasAny(d.sizes, BIG)) specs.push('大きいサイズあり');
      if (hasAny(d.sizes, KIDS)) specs.push('キッズサイズあり');
      /* 価格の後ろの文。アクリルキーホルダーは本体だけの価格が無い（プリント込みの 1 個あたり。最少個数は商品を読んだ後で合わせる） */
      const acrylic = isAcrylic(d);
      const priceNote = acrylic
        ? '<span>〜 / 1 個（プリント込み）</span><p data-pz-dsel-acrylic-note>' + escapeHtml(acrylicPriceNote(ACRYLIC_MIN_QTY)) + '</p>'
        : '<span>〜 / 1 枚（本体）</span><p>プリント代は、デザインに合わせてシミュレーターで計算します。</p>';
      el.detailBody.innerHTML =
        '<div class="pz-dsel__gal" data-pz-dsel-gal>' + (d.img ? '<img src="' + escapeHtml(d.img) + '" alt="">' : '') + '</div>' +
        '<div class="pz-dsel__dots" data-pz-dsel-dots></div>' +
        '<div class="pz-dsel__info">' +
          (d.brand ? '<div class="pz-dsel__info-brand">' + escapeHtml(d.brand) + '</div>' : '') +
          '<h3>' + escapeHtml(d.label) + '</h3>' +
          '<div class="pz-dsel__info-code">品番 ' + escapeHtml(d.code) + '</div>' +
          (d.price > 0 ? '<div class="pz-dsel__price"><b>' + yen(d.price) + '</b>' + priceNote + '</div>' : '') +
          (specs.length ? '<div class="pz-dsel__specs">' + specs.map(function (s) { return '<span>' + escapeHtml(s) + '</span>'; }).join('') + '</div>' : '') +
          (d.meth.length || acrylic ? '<div class="pz-dsel__meth" aria-label="できる加工">' + methodsHtml(d) + '</div>' : '') +
        '</div>' +
        '<div class="pz-dsel__dsec" data-pz-dsel-desc-sec><h4>商品について</h4><p class="pz-dsel__loading">読み込んでいます…</p></div>' +
        '<div class="pz-dsel__dsec" data-pz-dsel-color-sec><h4>カラー</h4><p class="pz-dsel__loading">読み込んでいます…</p></div>' +
        '<div class="pz-dsel__dsec" data-pz-dsel-size-sec><h4>サイズ表</h4><p class="pz-dsel__loading">読み込んでいます…</p></div>';
      el.detailBody.scrollTop = 0;
      sheets.open(el.detail);

      loadProduct(d.handle).then(function (p) {
        if (token !== detailToken) return;
        const descSec = el.detailBody.querySelector('[data-pz-dsel-desc-sec]');
        const colorSec = el.detailBody.querySelector('[data-pz-dsel-color-sec]');
        const sizeSec = el.detailBody.querySelector('[data-pz-dsel-size-sec]');
        if (!p) {
          if (descSec) descSec.remove();
          if (colorSec) colorSec.innerHTML = '<h4>カラー</h4><p class="pz-dsel__nochart">読み込めませんでした。商品ページでご確認ください。</p>';
          if (sizeSec) sizeSec.remove();
          return;
        }
        const media = Array.isArray(p.media) ? p.media.filter(function (m) { return m && (m.media_type === 'image' || !m.media_type) && m.src; }) : [];
        /* 1 枚目はシミュレーターの画像（一覧のカードと同じ服の写真。重ねる枠などは付けない）、続けて商品ページの写真 */
        const photos = media.filter(function (m) { return m.alt !== 'color_chart' && m.alt !== 'size_chart'; }).slice(0, 8);
        if (d.simImg) photos.unshift({ src: d.simImg, sim: true });
        const colors = media.filter(function (m) { return m.alt === 'color_chart'; });
        const sizes = media.filter(function (m) { return m.alt === 'size_chart'; });
        const gal = el.detailBody.querySelector('[data-pz-dsel-gal]');
        const dots = el.detailBody.querySelector('[data-pz-dsel-dots]');
        if (gal && photos.length) {
          gal.innerHTML = photos.map(function (m, i) {
            const base = m.sim ? String(m.src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') : m.src;
            return '<img src="' + escapeHtml(sized(base, 720)) + '" alt="' + escapeHtml(i === 0 ? d.label : '') + '"' + (i > 0 ? ' loading="lazy"' : '') + '>';
          }).join('');
          if (dots && photos.length > 1) {
            dots.innerHTML = photos.map(function (_, i) { return '<i class="' + (i === 0 ? 'is-on' : '') + '"></i>'; }).join('');
            gal.addEventListener('scroll', function () {
              const i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
              dots.querySelectorAll('i').forEach(function (dot, j) { dot.classList.toggle('is-on', i === j); });
            }, { passive: true });
          }
        }
        const text = plainText(p.description);
        if (descSec) {
          if (text) {
            descSec.innerHTML = '<h4>商品について</h4><p class="pz-dsel__desc" data-pz-dsel-desc></p><button type="button" class="pz-dsel__more" data-pz-dsel-more>続きを読む</button>';
            descSec.querySelector('[data-pz-dsel-desc]').textContent = text;
            const more = descSec.querySelector('[data-pz-dsel-more]');
            more.addEventListener('click', function () {
              descSec.querySelector('[data-pz-dsel-desc]').classList.add('is-open');
              more.remove();
            });
            requestAnimationFrame(function () {
              const desc = descSec.querySelector('[data-pz-dsel-desc]');
              if (desc && desc.scrollHeight <= desc.clientHeight + 2) more.remove();
            });
          } else {
            descSec.remove();
          }
        }
        if (colorSec) {
          colorSec.innerHTML = '<h4>カラー</h4>' + (colors.length
            ? colors.map(function (m) { return '<img class="pz-dsel__chart" loading="lazy" src="' + escapeHtml(sized(m.src, 900)) + '" alt="カラーチャート">'; }).join('')
            : '<p class="pz-dsel__nochart">カラーは、シミュレーターで選べます。</p>');
        }
        /* アクリルキーホルダー: 最少個数を商品の料金区分から読めたら、価格の下の文の数字を合わせる。サイズ表の画像が無ければ欄ごと出さない（「準備中」は出さない） */
        if (acrylic) {
          const note = el.detailBody.querySelector('[data-pz-dsel-acrylic-note]');
          const minQty = acrylicMinQty(p);
          if (note && minQty) note.textContent = acrylicPriceNote(minQty);
        }
        if (sizeSec && acrylic && !sizes.length) {
          sizeSec.remove();
        } else if (sizeSec) {
          sizeSec.innerHTML = '<h4>サイズ表</h4>' + (sizes.length
            ? sizes.map(function (m) { return '<img class="pz-dsel__chart" loading="lazy" src="' + escapeHtml(sized(m.src, 900)) + '" alt="サイズ表">'; }).join('')
            : '<p class="pz-dsel__nochart">サイズ表は準備中です。</p>');
        }
      });
    }

    enableDragToClose(el.detail, el.detailBody, sheets);

    /* カードを押すと詳細（Ctrl・Cmd・Shift・中ボタンは、リンクのまま新しいタブで開く） */
    root.addEventListener('click', function (e) {
      const card = e.target.closest('.pz-dpage__card');
      if (!card || !root.contains(card)) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const li = card.closest('[data-pz-item]');
      const code = li ? li.getAttribute('data-code') : '';
      const d = items.filter(function (it) { return it.code === code; })[0];
      if (!d) return;
      e.preventDefault();
      openDetail(d);
    });

    /* ---------------- マイデザイン ---------------- */
    let myPref = readStore('local', MY_KEY) === 'closed' ? 'closed' : 'open';
    let myReady = false;
    function applyMy() {
      if (!el.my || !myReady) return;
      const closed = !!state.q.trim() || myPref === 'closed';
      el.my.classList.toggle('is-closed', closed);
      const t = el.my.querySelector('[data-pz-dsel-my-toggle]');
      if (t) t.setAttribute('aria-expanded', closed ? 'false' : 'true');
    }

    function renderMy(list) {
      const p = pz();
      const valid = list.filter(function (d) {
        return d && p && p.normalizePublicId && p.normalizePublicId(d.publicId || d.displayId);
      });
      if (!valid.length) return;
      const count = el.my.querySelector('[data-pz-dsel-my-count]');
      const mini = el.my.querySelector('[data-pz-dsel-my-mini]');
      const rail = el.my.querySelector('[data-pz-dsel-my-rail]');
      if (count) count.textContent = valid.length + ' 件';
      const thumbs = valid.filter(function (d) { return /^https:\/\//.test(String(d.thumbnailUrl || '')); });
      if (mini) {
        mini.innerHTML = thumbs.slice(0, 3).map(function (d) {
          return '<img src="' + escapeHtml(String(d.thumbnailUrl)) + '" alt="" width="26" height="26" loading="lazy">';
        }).join('');
      }
      if (rail) {
        const fmt = function (iso) {
          const t = new Date(iso);
          return isNaN(t.getTime()) ? '' : (t.getMonth() + 1) + '/' + t.getDate();
        };
        rail.innerHTML = valid.slice(0, 12).map(function (d) {
          const id = p.normalizePublicId(d.publicId || d.displayId);
          const href = p.designPageUrl ? p.designPageUrl({ id: id }, true) : '?id=' + encodeURIComponent(id);
          const thumb = /^https:\/\//.test(String(d.thumbnailUrl || ''))
            ? '<img src="' + escapeHtml(String(d.thumbnailUrl)) + '" alt="" loading="lazy">'
            : '';
          const ordered = !!d.lastOrderedAt;
          const when = ordered ? fmt(d.lastOrderedAt) + ' 注文' : d.updatedAt ? fmt(d.updatedAt) + ' 更新' : '';
          return '<a class="pz-dsel__myc" href="' + escapeHtml(href) + '">' +
            '<span class="pz-dsel__myc-th">' + thumb + (ordered ? '<span class="pz-dsel__myc-badge">ご注文済み</span>' : '') + '</span>' +
            '<span class="pz-dsel__myc-t"><b>' + escapeHtml(d.name ? String(d.name) : 'デザイン ' + (p.formatPublicId ? p.formatPublicId(id) : id)) + '</b><span>' + escapeHtml(when) + '</span></span>' +
            '</a>';
        }).join('') + '<button type="button" class="pz-dsel__myc pz-dsel__myc--new" data-pz-dsel-my-new><i aria-hidden="true">＋</i>新しく作る<small>下から選ぶ</small></button>';
        const btn = rail.querySelector('[data-pz-dsel-my-new]');
        if (btn) {
          btn.addEventListener('click', function () {
            el.bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(function () { el.q.focus({ preventScroll: true }); }, 350);
          });
        }
      }
      el.my.hidden = false;
      myReady = true;
      applyMy();
    }

    if (el.my) {
      const toggle = el.my.querySelector('[data-pz-dsel-my-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          const nowClosed = el.my.classList.contains('is-closed');
          myPref = nowClosed ? 'open' : 'closed';
          writeStore('local', MY_KEY, myPref);
          if (myPref === 'open' && state.q.trim()) {
            el.q.value = '';
            state.q = '';
            render();
          }
          applyMy();
        });
      }
      const p = pz();
      if (p && typeof p.fetchMyDesigns === 'function') {
        p.fetchMyDesigns().then(function (r) {
          if (r && r.ok && Array.isArray(r.items) && r.items.length) renderMy(r.items);
        });
      }
    }

    /* 上に止まる高さ（サイトのヘッダーの下） */
    function measureTop() {
      const header = document.querySelector('.section-header');
      let top = 0;
      if (header) {
        const cs = window.getComputedStyle(header);
        if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(0, Math.round(header.getBoundingClientRect().height));
      }
      root.style.setProperty('--pz-dsel-top', top + 'px');
    }
    measureTop();
    window.addEventListener('resize', measureTop);

    render();
  }

  function boot() {
    document.querySelectorAll('[data-pz-dsel]').forEach(init);
  }

  /* assets/pz-design-embed.js（window.PzDesign）の後に動かす: 読み込み中なら DOMContentLoaded（defer の後）、済んでいればすぐ */
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
